export default "__VITE_ASSET__BifPJedO__"